export default __webpack_public_path__ + "static/media/header-sprite.124f2f47.svg";